module.exports = __webpack_public_path__ + "img/2024_L.e08ca0de.png";